import i18next from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import importTranslations from '@/lib/locales';

const i18n = i18next.createInstance();

const merge = (translations, firstFallback) => {
    if (Object.keys(translations).length) {
        return { ...firstFallback, ...translations };
    } else {
        // no need to merge if translations is empty
        return firstFallback;
    }
};

let translations = {};

// first, fill in the default locales
// ex the file named default-fr-fr.json will be used for fr, fr-fr, and as a fallback for other fr-* locales, like fr-ca
for (let filename of Object.keys(importTranslations)) {
    if (filename.startsWith('default-')) {
        const locale = filename.slice(-5).toLowerCase(); // return 'fr-fr'
        const localeParts = locale.split('-');
        const content = importTranslations[filename];
        translations[locale] = { translation: content };
        if (localeParts.length > 1) {
            translations[localeParts[0]] = { translation: content }; // if realLocale is fr-fr, store translations for fr
        }
    }
}

// then the non default locales, and use the default of their language as a fallback
for (let filename of Object.keys(importTranslations)) {
    if (filename.indexOf('default-') !== 0) {
        const locale = filename.slice(-5).toLowerCase(); // get 'fr-fr'
        const localeParts = locale.split('-');
        const content = importTranslations[filename];
        if (localeParts.length > 1) {
            translations[locale] = { translation: merge(content, translations[localeParts[0]]?.translation) };
        } else {
            translations[locale] = { translation: content };
        }
    }
}

i18n
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .init({
        supportedLngs: Object.keys(translations),
        lowerCaseLng: true,
        resources: translations,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        debug: import.meta.env.DEV === true,
        detection: {
            caches: [],
        },
    })
    .then()
    .catch(() => {
        console.error('Fail to load translations (i18next)');
    });

window.addEventListener('languagechange', () => window.location.reload());

export default i18n;
